import _ from 'lodash';
import moment from 'moment';

import {
  SYSTEM_HEALTH_CHANGE_VALUES,
} from '@shared/store/constants/mutationTypes';
import initialState from './systemHealthInitialState';

const mutations = {
  [SYSTEM_HEALTH_CHANGE_VALUES]: (state, payload) => {
    const {
      changes,
    } = payload;
    changes.forEach((change) => {
      const {
        field,
        value,
      } = change;
      if (state[field] !== undefined) {
        state[field] = value;
      }
    });
  },
  SYSTEM_HEALTH_CHANGE_VALUE: (state, payload) => {
    const { field, value } = payload;
    state[field] = value;
  },
  SYSTEM_HEALTH_CHANGE_TABLE_OPTION: (state, payload) => {
    const { field, value } = payload;

    if (typeof value === 'object') {
      if (value.includes(undefined)) {
        state.shTableOptions.sortBy = [];
        state.shTableOptions.sortDesc = [];
      }
    }
    state.shTableOptions[field] = value;
  },
  SYSTEM_HEALTH_CHANGE_ALERT_TYPE: (state, payload) => {
    const {
      tableData,
      tableMap,
      activeHealthTab,
      activeProfileTab,
      activeCorpFilter,
      activeCorpSystemHealth,
      newCompletedProfile,
      newIncompletedProfile,
      alertsCategory,
    } = payload;
    state.tableData = tableData;
    state.allSystemHealthMap = tableMap;
    state.completedProfile = newCompletedProfile;
    state.incompletedProfile = newIncompletedProfile;
    state.alertsCategory = alertsCategory;
    state.activeHealthTab = activeHealthTab;
    state.activeProfileTab = activeProfileTab;
    state.activeCorpFilter = activeCorpFilter;
    state.activeCorpSystemHealth = activeCorpSystemHealth;
    state.shTableOptions = initialState().shTableOptions;
  },
  SYSTEM_HEALTH_SET_SYSTEM_HEALTH: (state, payload) => {
    const {
      allSystemHealth,
      completedProfile,
      incompletedProfile,
      alertsCategory,
      iHaveEverything,
      selectedCorp,
    } = payload;
    state.allSystemHealth = allSystemHealth;
    state.iHaveEverything = iHaveEverything;
    state.alertsCategory = alertsCategory;
    state.completedProfile = completedProfile;
    state.incompletedProfile = incompletedProfile;
    state.activeCorpSystemHealth = allSystemHealth;
    state.tableData = completedProfile;
    state.selectedCorp = selectedCorp;
    state.loading = false;

    // This is used to refresh page when clearing alerts
    state.resetSystemHealthFlag = false;
  },
  SYSTEM_HEALTH_SET_HEADER: (state, payload) => {
    const { newHeaders } = payload;

    state.systemHealthTableHeaders = newHeaders;
  },
  SYSTEM_HEALTH_SET_HEADER_FILTER: (state, payload) => {
    const { header, filter } = payload;

    const filteredHeaders = state.systemHealthTableHeaders.map((h) => {
      if (h.text === header && filter) {
        h.align = 'start';
      } else if (h.text === header && !filter) {
        h.align = ' d-none';
      }
      return h;
    });

    let checkedLimit = 0;
    filteredHeaders.forEach((h) => {
      if (h.align === 'start') {
        checkedLimit += 1;
      }
    });

    if (checkedLimit <= 3) {
      filteredHeaders.forEach((h) => {
        if (h.align === 'start') {
          h.disable = true;
        }
      });
    } else {
      filteredHeaders.forEach((h) => {
        delete h.disable;
      });
    }

    state.systemHealthTableHeaders = _.cloneDeep(filteredHeaders);
  },
  SYSTEM_HEALTH_SET_EXPANDABLE_ROW: (state, payload) => {
    const {
      customer, hvac, filters, notifications, currentExpandedRowId, chronicAlerts,
    } = payload;

    state.customer = customer;
    state.hvac = hvac;
    state.filters = filters;
    state.notifications = notifications;
    state.currentExpandedRowId = currentExpandedRowId;
    state.expandableLoading = false;
    state.chronicAlerts = chronicAlerts;
    state.unmuteDate = moment().add(1, 'months').format('YYYY-MM-DD');
  },
  SYSTEM_HEALTH_SET_SYSTEM_HEALTH_AGAIN: (state) => {
    const tempCorpId = state.selectedCorp;
    Object.assign(state, initialState());
    state.selectedCorp = tempCorpId;
    state.resetSystemHealthFlag = true;
  },
  SYSTEM_HEALTH_SET_EXPANDABLE_ROW_AGAIN: (state, payload) => {
    const { newNotifications } = payload;

    const { systemHealthExpandableData, currentExpandedRowId } = state;

    let data;
    if (systemHealthExpandableData.has(currentExpandedRowId)) {
      data = systemHealthExpandableData.get(currentExpandedRowId);
    }

    systemHealthExpandableData.set(currentExpandedRowId, {
      customer: data.customer,
      hvac: data.hvac,
      filters: data.filters,
      notifications: newNotifications,
    });

    state.notifications = newNotifications;
  },
  SYSTEM_HEALTH_CHANGE_ALERT_CATEGORY: (state, payload) => {
    const { newAlertsCategory } = payload;

    state.alertsCategory = _.cloneDeep(newAlertsCategory);
  },
  SYSTEM_HEALTH_RESET_SYSTEM_HEALTH_LOADER: (state) => {
    state.expandableLoading = true;
  },
  SYSTEM_HEALTH_RESET_SYSTEM_HEALTH: (state) => {
    state.expandableLoading = true;
    state.systemHealthExpandableData = new Map();
  },
  ADMIN_LOGOUT: (state) => {
    Object.assign(state, initialState());
  },
};

export default mutations;
